import type { EarliestStagedDateDto } from '@signalvote/shared';
import type { CurrentRead } from '@signalvote/data';
import { apiJson } from './apiFetch';
import { financeReadKeys } from '../../lib/queryKeys';
import { campaignHeaders, defineQuery } from '../../lib/data';

const useEarliestStagedDateRead = defineQuery({
  key: financeReadKeys.earliestStagedDate,
  reads: 'GET /api/finance/staged/earliest-date',
  fetch: (_params: undefined, { signal, campaignId }) =>
    apiJson<EarliestStagedDateDto>('/api/finance/staged/earliest-date', {
      signal,
      headers: campaignHeaders(campaignId),
      error: 'Failed to fetch earliest staged date',
    }),
  staleTime: 60_000,
});

export function useEarliestStagedDate(): CurrentRead<EarliestStagedDateDto> {
  return useEarliestStagedDateRead(undefined);
}
